module.exports = __webpack_public_path__ + "img/call.b60879bf.svg";